// extracted by mini-css-extract-plugin
export var container = "footer-module--container--HXu2X";
export var content = "footer-module--content--1Vev3";
export var title = "footer-module--title--2l0q1";
export var subtitle = "footer-module--subtitle--1BYdn";
export var logoLink = "footer-module--logoLink--hwO9v";
export var logo = "footer-module--logo--3sxBO";
export var smallPrint = "footer-module--small-print--2XYiS";